var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFifthCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1029,
    height: 1029,
    viewBox: "0 0 1029 1029",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.519 1028.05C798.298 1028.05 1028.35 798.003 1028.35 514.223C1028.35 230.443 798.298 0.394072 514.519 0.394072C230.739 0.394072 0.68997 230.443 0.68997 514.223C0.68997 798.003 230.739 1028.05 514.519 1028.05ZM514.519 1028.45C798.516 1028.45 1028.74 798.22 1028.74 514.223C1028.74 230.225 798.516 0 514.519 0C230.521 0 0.295898 230.225 0.295898 514.223C0.295898 798.22 230.521 1028.45 514.519 1028.45Z",
    fill: "#D7544F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M989.827 496.858L1028.23 495.734L1028.34 499.207L989.929 500.33L989.827 496.858Z",
    fill: "url(#paint0_linear_499_1644)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_499_1644",
    x1: 514.519,
    y1: -3.50677e-10,
    x2: 514.519,
    y2: 1028.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifthCircle);
export default __webpack_public_path__ + "static/media/fifth-circle.3cc293eca77a6dd352dc3171a6f0083d.svg";
export { ForwardRef as ReactComponent };